module.exports = __webpack_public_path__ + "img/Arrival__Loading__Icon--has-token@2x.d4d7df3d.png";